import React from "react";
import { Link, Route } from "react-router-dom";

import TournamentsLayout from "../pages/Tournaments/Layout";
import {
    ITournament,
    ITournamentSchedule,
    ITeamSchedule,
    IMasterTournament,
} from "../types/api";

import TournamentsIndex, {
    loader as TournamentsLoader,
} from "../pages/Tournaments/Index";
import Tournament, {
    loader as TournamentLoader,
} from "../pages/Tournaments/Tournament";
import TournamentSchedule, {
    loader as ScheduleLoader,
} from "../pages/Tournaments/TournamentSchedule";
import Bracket, { loader as BracketLoader } from "../pages/Tournaments/Bracket";
import TournamentTeam, {
    loader as TournamentTeamLoader,
} from "../pages/Tournaments/TournamentTeam";
import NotFound from "../components/NotFound";
import TournamentOverview, {
    loader as OverviewLoader,
} from "../pages/Tournaments/Overview";
import { isChildTournament } from "../lib/utils";

export default (
    <Route
        path="tournaments"
        handle={{
            crumb: () => <Link to="/tournaments">Tournaments</Link>,
        }}
        element={<TournamentsLayout />}
    >
        <Route
            index
            element={<TournamentsIndex />}
            loader={TournamentsLoader}
            handle={{
                header: () => "Tournaments",
            }}
        />
        <Route
            path=":tournamentId"
            loader={TournamentLoader}
            handle={{
                crumb: ({
                    tournament,
                    masterName,
                }: {
                    tournament: ITournament | IMasterTournament;
                    masterName?: IMasterTournament["name"];
                }) => (
                    <Link to={`/tournaments/${tournament.id}`}>
                        {`${masterName}${isChildTournament(tournament) ? ` ${tournament.ageLevel}` : ""}`}
                    </Link>
                ),
            }}
        >
            <Route
                index
                element={<Tournament />}
                loader={TournamentLoader}
                handle={{
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="schedule"
                element={<TournamentSchedule />}
                loader={ScheduleLoader}
                handle={{
                    crumb: ({
                        schedule,
                    }: {
                        schedule: ITournamentSchedule;
                    }) => (
                        <Link
                            to={`/tournaments/${schedule.tournament}/schedule`}
                        >
                            Schedule
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="bracket"
                element={<Bracket />}
                loader={BracketLoader}
                handle={{
                    crumb: (tournament: ITournament) => (
                        <Link to={`/tournaments/${tournament.id}/playoffs`}>
                            Bracket
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="overview"
                element={<TournamentOverview />}
                loader={OverviewLoader}
                handle={{
                    crumb: (tournament: ITournament) => (
                        <Link to={`/tournaments/${tournament.id}/overview`}>
                            Overview
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="teams/:teamId"
                element={<TournamentTeam />}
                loader={TournamentTeamLoader}
                handle={{
                    crumb: ({
                        schedule,
                        tournamentId,
                    }: {
                        schedule: ITeamSchedule;
                        tournamentId: ITournament["id"];
                    }) => (
                        <Link
                            to={`/tournaments/${tournamentId}/teams/${schedule.teamId}`}
                        >
                            {schedule.teamName}
                        </Link>
                    ),
                    header: ({ header }: { header: string }) => header,
                }}
            />
            <Route
                path="*"
                element={<NotFound parent="tournaments" />}
                handle={{ header: () => "Tournament Page Not Found" }}
            />
        </Route>
    </Route>
);
